import { useMemo } from 'react';
import type { JourneyPickerCategory } from 'voyager';
import { useTranslations } from '@lang';

const CATEGORY_KEYS: Record<string, string> = {
  rooms: 'app.rooms',
  rates: 'app.rates',
  spa: 'category.spaDays',
  dining: 'app.dining',
};

export function useNavCategories(): JourneyPickerCategory[] {
  const { t } = useTranslations();

  return useMemo(
    () =>
      Object.entries(CATEGORY_KEYS).map(([id, key]) => ({
        id,
        label: t(key as Parameters<typeof t>[0]),
      })),
    [t]
  );
}
